import { useEffect, useState } from "react";
import { countdown } from "../../hooks/useTimer";

function DateTimer({ onExpirationTime, timerStartDate, timerEndDate }) {
  const [timer, setTimer] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [timerZero, setTimerZero] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(countdown(timerStartDate, timerEndDate));
    }, 1000);
    return () => clearInterval(interval);
  }, [timerStartDate, timerEndDate]);

  useEffect(() => {
    setTimerZero(timer.days + timer.hours + timer.minutes + timer.seconds === 0);
    if (timerZero) {
      onExpirationTime();
    }
  }, [timerZero, timer]);

  const addZero = (obj) =>
    obj.toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });

  return (
    <>
      {timer.days > 0 && <>{addZero(timer.days)}d : </>}
      {addZero(timer.hours)}h : {addZero(timer.minutes)}m
      {timer.days < 1 && <> : {addZero(timer.seconds)}s</>}
    </>
  );
}

export default DateTimer;
